import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import ArrowCircleIcon from "../../../../assets/svgIcons/ArrowCircleIcon";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import { truncateString } from "../../../../helpers";
import { CopyIcon } from "../../../../assets/svgIcons";
import CopyToClipboard from "react-copy-to-clipboard";
import { useContext } from "react";
import { ToastContext } from "../../../../hooks/context";
import { intergratedTerminalInfo } from "../../../../localdata/intergratedTerminalInfo";
import { useGetTerminalBusinessAccount } from "../../../../hooks/api/queries/useTerminals";

export const WebhookUrl = ({ terminalType, closeModal = () => {} }) => {
  const { data: businessAccountDetails, isLoading: isFetchBusinessDetails } =
    useGetTerminalBusinessAccount({
      path: intergratedTerminalInfo?.[terminalType]?.getEndpoint,
      queryKey: intergratedTerminalInfo?.[terminalType]?.getQueryKey,
    });

  const triggerToast = useContext(ToastContext);

  return (
    <div>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isFetchBusinessDetails}
      >
        <div className={globalStyles.cardWithBorder}>
          <h5>
            <span className="error--text">*</span>Your Webhook URL
          </h5>
          <p>
            Copy your webhook url below and add it to your{" "}
            {intergratedTerminalInfo?.[terminalType]?.secondaryName} business
          </p>

          <div
            className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between`}
            style={{ borderRadius: "0px", gap: "5px" }}
          >
            <p className="small-text-size">
              {truncateString(businessAccountDetails?.webhook_url || "", 40)}
            </p>

            <CopyToClipboard
              onCopy={() => {
                triggerToast("Copied", "success");
              }}
              text={businessAccountDetails?.webhook_url || ""}
            >
              <primaryComponents.Button
                classNames={"btn btn--outline smallBtn"}
              >
                <CopyIcon color="#7647ee" className="mr-1" /> Copy
              </primaryComponents.Button>
            </CopyToClipboard>
          </div>
        </div>

        <primaryComponents.Button
          classNames={"btn btn--primary cover mt-4"}
          onClick={closeModal}
        >
          <ArrowCircleIcon className="mr-1" />I Have Added My Webhook URL to My{" "}
          {intergratedTerminalInfo?.[terminalType]?.secondaryName} Business
        </primaryComponents.Button>
      </secondaryComponents.LoaderHelper>
    </div>
  );
};
